import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from '../shared/ProtectedRoute';
import AdminLayout from '../layouts/AdminLayout';

// Pages
import Login from '../pages/Login';
import ForgotPassword from '../pages/auth/ForgotPassword';
import Dashboard from '../pages/Dashboard';
import GetAllBanners from '../pages/banner/GetAllBanners';
import ModifyBanner from '../pages/banner/ModifyBanner';
import GetAllFqas from '../pages/faq/GetAllFqas';
import ModifyFaq from '../pages/faq/ModifyFaq';
import Contact from '../pages/contact/Contact';
import GetAllCms from '../pages/cms/GetAllCms';
import ModifyCms from '../pages/cms/ModifyCms';
import GetAllCategories from '../pages/categories/GetAllCategories';
import ModifyCategory from '../pages/categories/ModifyCategory';
import GetAllSubCategories from '../pages/sub-categories/GetAllSubCategories';
import ModifySubCategories from '../pages/sub-categories/ModifySubCategories';
import GetAllProducts from '../pages/products/GetAllProducts';
import ModifyProducts from '../pages/products/ModifyProducts';
import ProductDetails from '../pages/products/ProductDetails';
import GetAllVariants from '../pages/varients/GetAllVarients';
import ModifyVarients from '../pages/varients/ModifyVarients';
import GetAllUsers from '../pages/users/GetAllUsers';
import ViewUserDetails from '../pages/users/ViewUserDetails';
import ViewUserAddress from '../pages/users/ViewUserAddress';
import GetAllVendors from '../pages/grocery-vendor/GetAllVendors';
import CreateAndModifyVendor from '../pages/grocery-vendor/CreateAndModifyVendor';
import VendorDetails from '../pages/grocery-vendor/VendorDetails';
import ViewInventory from '../pages/grocery-vendor/ViewInventory';

import GetAllFoodVendors from '../pages/food-vendor/GetAllFoodVendors';
import CreateAndModifyFoodVendor from '../pages/food-vendor/CreateAndModifyFoodVendor';
import FoodVendorDetails from '../pages/food-vendor/FoodVendorDetails';
import ViewVendorBankDetails from '../pages/food-vendor/ViewVendorBankDetails';
import GetMenuItems from '../pages/food-vendor/GetMenuItems';

import GetAllPartners from '../pages/partners/GetAllPartners';
import CreateAndModifyPartner from '../pages/partners/CreateAndModifyPartner';
import GetAllPartnerBookings from '../pages/partners/GetAllPartnerBookings';
import ViewBookingDetails from '../pages/partners/ViewBookingDetails';

import GetAllServiceLocations from '../pages/service-location/GetAllServiceLocations';
import CreateAndModifyServiceLocations from '../pages/service-location/CreateAndModifyServiceLocations';
import GetAllFoodCategories from '../pages/food-category/GetAllFoodCategories';

import CreateAndModifyFoodCategory from '../pages/food-category/CreateAndModifyFoodCategory';
import GetAllTimeSlots from '../pages/timeslots/GetAllTimeSlots';
import ModifyTimeSlots from '../pages/timeslots/ModifyTimeSlots';

import GetAllFoodBookings from '../pages/bookings/food-bookings/GetAllFoodBookings';
import ViewFoodBookingDetails from '../pages/bookings/food-bookings/ViewFoodBookingDetails';

import GetAllGroceryBookings from '../pages/bookings/grocery-bookings/GetAllGroceryBookings';
import ViewGroceryBookingDetails from '../pages/bookings/grocery-bookings/ViewGroceryBookingDetails';
import ViewGroceryPartners from '../pages/bookings/grocery-bookings/ViewGroceryPartners';

import GetAllFeatures from '../pages/features/GetAllFeatures';
import CreateAndModifyFeatures from '../pages/features/CreateAndModifyFeatures';

import GetAllServiceConfigs from '../pages/service-configurations/GetAllServiceConfigs';
import CreateAndModifyServiceConfigs from '../pages/service-configurations/CreateAndModifyServiceConfigs';

import GetAllCoupons from '../pages/coupons/GetAllCoupons';
import CreateAndModifyCoupons from '../pages/coupons/CreateAndModifyCoupons';
import ViewCouponDetails from '../pages/coupons/ViewCouponDetails';
import PushNotifications from '../pages/notifications/PushNotifications';

import GetAllPaymentTransactions from '../pages/payment-transactions/GetAllPaymentTransactions';
import ViewPaymentTransactionDetails from '../pages/payment-transactions/ViewPaymentTransactionDetails';

import GetAllPayoutList from '../pages/vendor-wallet/GetAllPayoutList';

import Bookings from '../pages/bookings/Bookings';
import GetAllServiceBookings from '../pages/bookings/service-bookings/GetAllServiceBookings';
import ViewServiceBookingDetails from '../pages/bookings/service-bookings/ViewServiceBookingDetails';
import ViewProfileDetails from '../pages/profile/ViewProfileDetails';
import DisplayServices from '../pages/services/DisplayServices';
import DisplaySubServices from '../pages/services/sub-services/DisplaySubServices';
import CreateAndModifySubServices from '../pages/services/sub-services/CreateAndModifySubServices';
import DisplayServiceOptions from '../pages/services/service-options/DisplayServiceOptions';
import CreateAndModifyServiceOptions from '../pages/services/service-options/CreateAndModifyServiceOptions';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Entry */}
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />

      {/* Protected Admin Routes */}
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="banners" element={<GetAllBanners />} />
          <Route path="banners/modify/:id?" element={<ModifyBanner />} />
          <Route path="faqs" element={<GetAllFqas />} />
          <Route path="faqs/modify/:id?" element={<ModifyFaq />} />
          <Route path="contact" element={<Contact />} />
          <Route path="cms" element={<GetAllCms />} />
          <Route path="cms/modify/:type?" element={<ModifyCms />} />
          <Route path="categories" element={<GetAllCategories />} />
          <Route path="categories/modify/:id?" element={<ModifyCategory />} />
          <Route path="categories/:categoryId/items" element={<GetAllSubCategories />} />
          <Route path="food-categories" element={<GetAllFoodCategories />} />
          <Route path="food-categories/create" element={<CreateAndModifyFoodCategory />} />
          <Route path="food-categories/modify/:id" element={<CreateAndModifyFoodCategory />} />
          <Route path="sub-categories/modify/:categoryId?/:id?" element={<ModifySubCategories />} />
          <Route path="sub-categories/:subCategoryId/products" element={<GetAllProducts />} />
          <Route path="sub-categories/:subCategoryId/products/:productId/details" element={<ProductDetails />} />
          <Route path="sub-categories/:subCategoryId/products/:productId/variants" element={<GetAllVariants />} />
          <Route path="users" element={<GetAllUsers />} />
          <Route path="users/:id/details" element={<ViewUserDetails />} />
          <Route path="users/:id/address" element={<ViewUserAddress />} />
          <Route path="service-location" element={<GetAllServiceLocations />} />
          <Route path="service-location/create" element={<CreateAndModifyServiceLocations />} />
          <Route path="service-location/modify/:id" element={<CreateAndModifyServiceLocations />} />
          <Route path="vendors" element={<GetAllVendors />} />
          <Route path="vendors/create" element={<CreateAndModifyVendor />} />
          <Route path="vendors/modify/:id" element={<CreateAndModifyVendor />} />
          <Route path="vendors/:id/details" element={<VendorDetails />} />
          <Route path="vendors/:id/inventory" element={<ViewInventory />} />

          {/* Partners mapped routes */}
          <Route path="partners" element={<GetAllPartners />} />
          <Route path="partners/create" element={<CreateAndModifyPartner />} />
          <Route path="partners/modify/:id?" element={<CreateAndModifyPartner />} />
          <Route path="partners/:partnerId/bookings" element={<GetAllPartnerBookings />} />
          <Route path="partners/bookings/details/:id" element={<ViewBookingDetails />} />

          {/* Food Vendors Routes */}
          <Route path="vendors/food" element={<GetAllFoodVendors />} />
          <Route path="vendors/food/create" element={<CreateAndModifyFoodVendor />} />
          <Route path="vendors/food/modify/:id" element={<CreateAndModifyFoodVendor />} />
          <Route path="vendors/food/details/:id" element={<FoodVendorDetails />} />
          <Route path="vendors/food/bank-details/:vendorId" element={<ViewVendorBankDetails />} />
          <Route path="vendors/food/menu-items/:vendorId" element={<GetMenuItems />} />
          <Route path="variants/modify/:productId?/:id?" element={<ModifyVarients />} />
          <Route path="products/modify/:subCategoryId?/:id?" element={<ModifyProducts />} />
          
          {/* Time Slots Routes */}
          <Route path="timeslots/all" element={<GetAllTimeSlots />} />
          <Route path="timeslots/modify/:id?" element={<ModifyTimeSlots />} />

          {/* Bookings Routes */}
          <Route path="bookings/food/all" element={<GetAllFoodBookings />} />
          <Route path="bookings/food/details/:id" element={<ViewFoodBookingDetails />} />
          <Route path="bookings/grocery/all" element={<GetAllGroceryBookings />} />
          <Route path="bookings/grocery/details/:id" element={<ViewGroceryBookingDetails />} />
          <Route path="bookings/grocery/assign-partner/:id" element={<ViewGroceryPartners />} />

          {/* Product Features Routes */}
          <Route path="features" element={<GetAllFeatures />} />
          <Route path="features/create" element={<CreateAndModifyFeatures />} />
          <Route path="features/modify/:id" element={<CreateAndModifyFeatures />} />

          {/* Service Configuration Routes */}
          <Route path="service-configs" element={<GetAllServiceConfigs />} />
          <Route path="service-configs/create" element={<CreateAndModifyServiceConfigs />} />
          <Route path="service-configs/modify/:id" element={<CreateAndModifyServiceConfigs />} />

          {/* Push Notifications Routes */}
          <Route path="push-notifications" element={<PushNotifications />} />

          {/* Coupon Routes */}
          <Route path="coupons" element={<GetAllCoupons />} />
          <Route path="coupons/details/:id" element={<ViewCouponDetails />} />
          <Route path="coupons/create" element={<CreateAndModifyCoupons />} />
          <Route path="coupons/modify/:id" element={<CreateAndModifyCoupons />} />

          {/* Payment Transactions Routes */}
          <Route path="payment-transactions" element={<GetAllPaymentTransactions />} />
          <Route path="payment-transactions/view/:id" element={<ViewPaymentTransactionDetails />} />

          {/* Vendor Wallet / Payouts */}
          <Route path="vendor-wallet/payouts" element={<GetAllPayoutList />} />

          {/* Bookings */}
          <Route path="bookings" element={<GetAllServiceBookings />} />
          <Route path="bookings/service-bookings" element={<GetAllServiceBookings />} />
          <Route path="bookings/service-bookings/view/:id" element={<ViewServiceBookingDetails />} />
          <Route path="bookings/grocery-bookings" element={<GetAllGroceryBookings />} />
          <Route path="bookings/food-bookings" element={<GetAllFoodBookings />} />
          <Route path="bookings/delivery-bookings" element={<Bookings />} />

          {/* Profile */}
          <Route path="profile" element={<ViewProfileDetails />} />

          {/* Services */}
          <Route path="services" element={<DisplayServices />} />
          <Route path="services/:categoryId/sub-services" element={<DisplaySubServices />} />
          <Route path="services/:categoryId/sub-services/create" element={<CreateAndModifySubServices />} />
          <Route path="services/:categoryId/sub-services/edit/:subServiceId" element={<CreateAndModifySubServices />} />
          <Route path="services/:subCategoryId/service-options" element={<DisplayServiceOptions />} />
          <Route path="services/service-options/:subServiceId" element={<DisplayServiceOptions />} />
          <Route path="services/service-options/create/:subServiceId" element={<CreateAndModifyServiceOptions />} />
          <Route path="services/service-options/edit/:optionId" element={<CreateAndModifyServiceOptions />} />

          <Route path="*" element={<Dashboard />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default AppRoutes;
